<template>
  <model-crud
    :model="model"
    :fields="fields"
    :editable="false"
    :deletable="false"
    :include="['recording', 'user']"
    :fetchFilters="{ approved: 'false' }"
  >
    <template slot="_src" slot-scope="row">
      {{ row.item.recording.source }}
    </template>
    <template slot="_dst" slot-scope="row">
      {{ row.item.recording.destination }}
    </template>
    <template slot="_actions" slot-scope="row">
      <div class="text-xs-right no-wrap">
        <v-btn icon class="ma-0" @click="approve(row.item)" v-tooltip="{ content: $t('audit.approve') }"><v-icon>done</v-icon></v-btn>
        <v-btn icon class="ma-0" @click="deny(row.item)" v-tooltip="{ content: $t('audit.deny') }"><v-icon>clear</v-icon></v-btn>
      </div>
    </template>
  </model-crud>
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import RecordingRequest from '@/models/RecordingRequest'
import User from '@/models/User'

export default {
  data () {
    return {
      model: RecordingRequest,
      fields: {
        created: {
          label: this.$t('headers.changeDate'),
          type: 'date'
        },
        user: {
          type: 'reference',
          model: User,
          label: this.$t('headers.user')
        },
        _src: {
          filterable: false,
          label: this.$t('headers.source')
        },
        _dst: {
          filterable: false,
          label: this.$t('headers.destination')
        },
        operation: {
          type: 'enum',
          values: RecordingRequest.enums.operation,
          label: this.$t('headers.operation')
        },
        _actions: {
          label: '',
          filterable: false
        }
      }
    }
  },
  methods: {
    approve (item) {
      item.approved = true
      RecordingRequest.update(item, ['approved'])
    },
    deny (item) {
      RecordingRequest.delete(item)
    }
  },
  components: {
    ModelCrud
  }
}
</script>



// WEBPACK FOOTER //
// RecordingRequests.vue?287a5cd8